/* eslint-disable eqeqeq */
import CryptoJS from "crypto-js";

// Helper to get iv from persist:root in sessionStorage, then Redux, then sessionStorage ivkey
// function getIvFromPersistedStore() {
//   try {
//     // Try from persist:root in sessionStorage
//     const persisted = sessionStorage.getItem('persist:root');
//     if (persisted) {
//       const rootObj = JSON.parse(persisted);
//       if (rootObj.clientMaster) {
//         const clientMaster = JSON.parse(rootObj.clientMaster);
//         if (clientMaster.enciv) {
//           return clientMaster.enciv;
//         }
//       }
//     }
//     // Try from window.store if available (standard Redux setup)
//     if (window.store && window.store.getState) {
//       const s = window.store.getState();
//       if (s && s.clientMaster && s.clientMaster.enciv) {
//         return s.clientMaster.enciv;
//       }
//     }
//     // Try from Redux DevTools if available
//     const state = window.__REDUX_DEVTOOLS_EXTENSION__?.getState?.() || null;
//     if (state && state["client-master"] && state["client-master"].enciv) {
//       return state["client-master"].enciv;
//     }
//   } catch (e) {}
//   return sessionStorage.getItem("ivkey");
// }


export const encryptAES = (data, mode = 2) => {
  if (!data) return "";

  // Validate secretKey and IV before encryption
  const rawKey = mode == 2 ? process.env.REACT_APP_AES_KEY_2 : process.env.REACT_APP_AES_KEY_1;
  const rawIv  = mode == 2 ? process.env.REACT_APP_ECP_2    : process.env.REACT_APP_AES_IV_1;
  if (!rawKey || !rawIv) {
    const keyVar = mode == 2 ? "REACT_APP_AES_KEY_2" : "REACT_APP_AES_KEY_1";
    const ivVar  = mode == 2 ? "REACT_APP_ECP_2"     : "REACT_APP_AES_IV_1";
    const missing = [];
    if (!rawKey) missing.push(keyVar);
    if (!rawIv)  missing.push(ivVar);
    const msg = `Encryption configuration error (mode ${mode}): missing env var(s): ${missing.join(", ")}. Please contact support.`;
    console.error(msg);
    throw new Error(msg);
  }

  let dataToEncrypt;
  var secretKey = CryptoJS.enc.Utf8.parse(process.env.REACT_APP_AES_KEY_1);
  var iv = CryptoJS.enc.Utf8.parse(process.env.REACT_APP_AES_IV_1);
  if (mode == 2) {
    secretKey = CryptoJS.enc.Utf8.parse(process.env.REACT_APP_AES_KEY_2);
    iv = CryptoJS.enc.Utf8.parse(process.env.REACT_APP_ECP_2);
    // const ivKey = sessionStorage.getItem("ivkey");
    // if (ivKey) {
    //   iv = CryptoJS.enc.Utf8.parse(ivKey);
    // } else {
    //   iv = CryptoJS.enc.Utf8.parse(process.env.REACT_APP_ECP_2);
    // }
  }
  if (typeof data === "string") {
    dataToEncrypt = data;
  } else if (typeof data === "object") {
    dataToEncrypt = JSON.stringify(data);
  } else {
    throw new Error("Unsupported data type for encryption");
  }

  const encrypted = CryptoJS.AES.encrypt(dataToEncrypt, secretKey, {
    iv: iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  });

  return encrypted.toString();
};

export const decryptAES = (cipherText, mode = 2) => {
  if (!cipherText) return "";

  // Validate secretKey and IV before decryption
  const rawKey = mode == 2 ? process.env.REACT_APP_AES_KEY_2 : process.env.REACT_APP_AES_KEY_1;
  const rawIv  = mode == 2 ? process.env.REACT_APP_ECP_2    : process.env.REACT_APP_AES_IV_1;
  if (!rawKey || !rawIv) {
    const keyVar = mode == 2 ? "REACT_APP_AES_KEY_2" : "REACT_APP_AES_KEY_1";
    const ivVar  = mode == 2 ? "REACT_APP_ECP_2"     : "REACT_APP_AES_IV_1";
    const missing = [];
    if (!rawKey) missing.push(keyVar);
    if (!rawIv)  missing.push(ivVar);
    const msg = `Decryption configuration error (mode ${mode}): missing env var(s): ${missing.join(", ")}. Please contact support.`;
    console.error(msg);
    throw new Error(msg);
  }

  var secretKey = CryptoJS.enc.Utf8.parse(process.env.REACT_APP_AES_KEY_1);
  var iv = CryptoJS.enc.Utf8.parse(process.env.REACT_APP_AES_IV_1);
  if (mode == 2) {
    secretKey = CryptoJS.enc.Utf8.parse(process.env.REACT_APP_AES_KEY_2);
    iv = CryptoJS.enc.Utf8.parse(process.env.REACT_APP_ECP_2);
    // const ivKey = sessionStorage.getItem("ivkey");
    // if (ivKey) {
    //   iv = CryptoJS.enc.Utf8.parse(ivKey);
    // } else {
    //   iv = CryptoJS.enc.Utf8.parse(process.env.REACT_APP_ECP_2);
    // }
  }
  const decrypted = CryptoJS.AES.decrypt(cipherText, secretKey, {
    iv: iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  });

  const decryptedText = decrypted.toString(CryptoJS.enc.Utf8);

  try {
    return JSON.parse(decryptedText);
  } catch (error) {
    return decryptedText;
  }
};
